import request from '@webtrader/core/request';

const paymentUrl = () => {
  return request.get<string>('/api/payment/v1/url');
};

export default paymentUrl;
